import { render, staticRenderFns } from "./ModalConfirmDiscount.vue?vue&type=template&id=54f81b22&scoped=true"
import script from "./ModalConfirmDiscount.vue?vue&type=script&lang=js"
export * from "./ModalConfirmDiscount.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmDiscount.vue?vue&type=style&index=0&id=54f81b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f81b22",
  null
  
)

export default component.exports